export const API_BASE_URL: string = import.meta.env.VITE_BASE_URL;
export const API_TIMEOUT: number = 20000;
export const WEBSOCKET_BASE_URL: string = import.meta.env.VITE_WEBSOCKET_BASE_URL;

export const STORAGE_KEY = {
    token: "token",
};
